export default __webpack_public_path__ + "static/media/mon-projet.d54a7dae.svg";